import $ from './jquery-shim.js';
import Cookies from 'js-cookie';
export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.headerOverView();
    this.removeCssHoverOnIE();
    this.headerSearch();
    this.videoPopUp();
    // this.confirmBox();
    this.selectSlider();
    this.asideNavBar();
    this.rulesBlock();
    this.tingleBox();
    this.documentTabHeight();

  }

  /**
   * カスタム関数
   */

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }

  removeCssHoverOnIE() {
    function hasTouch() {
      return 'ontouchstart' in document.documentElement
        || navigator.maxTouchPoints > 0
        || navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) { // remove all the :hover stylesheets
      try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
          var styleSheet = document.styleSheets[si];
          if (!styleSheet.rules) continue;

          for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
            if (!styleSheet.rules[ri].selectorText) continue;

            if (styleSheet.rules[ri].selectorText.match(':hover')) {
              styleSheet.deleteRule(ri);
            }
          }
        }
      } catch (ex) {
      }
    }
  }

  headerOverView() {
    let $target = $('.js-overs');

    $target.hover(
      function () {
        $(this).find($('.c-overs')).addClass('is-active');
      },
      function () {
        $(this).find($('.c-overs')).removeClass('is-active');
      }
    )
  }


  headerSearch() {
    let $target = $('.js-search-trigger');
    if (!$target) {
      return false;
    }
    $target.on('click', function () {
      $(this).next('.l-header__sp-input').toggleClass('is-active');
    });
  }


  videoPopUp() {
    let $target = $('.js-video-target');
    let $trigger = $('.js-video-trigger');
    let $content = $('.js-video-content');
    let $close = $('.js-video-close');
    let $video = $content.find('iframe');
    if ($target.length <= 0) {
      return false;
    }

  console.log($video)


    $trigger.on('click', function () {
      $(this).next($content).addClass('is-active');
    });

    $close.on('click', function () {
      $(this).parent($content).removeClass('is-active');
    });

  }



  selectSlider() {
    if ($(".js-tab-select").length < 0) {
      return;
    }
    $('.js-tab-select').change(function () {
      var val = $('.js-tab-select option:selected').val();
      if (val == '') {
        return;
      }
      $('.js-tab-select-content.is-active').removeClass("is-active");
      $('.js-tab-select-content[data-tab-name=' + val + ']').addClass("is-active");
    });
  }

  asideNavBar() {
    window.onload = function() {
        $('.js-sidenav').each(function () {
          //後で使うので thisを保存
          let thisnav = $(this);
          //is-currentの位置を取得
          let current = $(this).children('.is-current');
          let current_top = 0;
          if (current.length) {
            thisnav.find('.c-aside__nav-bar').show();
            current_top = current.position().top;
          } else {
            thisnav.find('.c-aside__nav-bar').hide();
          }
          let top = current_top;
          //is-currentの位置に棒を移動
          thisnav.find('.c-aside__nav-bar').css('top', top);

          //aにマウスが乗ったら
          $(this).find('.c-aside__nav-link').on({
            mouseenter: function () {
              thisnav.find('.c-aside__nav-bar').show();
              //マウスがのっているaの位置をtopに入れ直す
              top = $(this).position().top;
              //棒を移動
              thisnav.find('.c-aside__nav-bar').css('top', top);
            },
          })
          $(this).on({
            mouseleave: function () {
              //js-sidenavの範囲から外れたら 棒をis-currentに戻す
              if (current.length) {
                top = current_top;
                thisnav.find('.c-aside__nav-bar').css('top', top);
              } else {
                thisnav.find('.c-aside__nav-bar').hide();
              }
            }
          })
        });
    }
  }

  rulesBlock() {
    let $block = $('.js-rules');
    let $target = $block.find('.js-rules-target');
    let $button = $block.find('.js-rules-button');

    if ($block.length <= 0 || $target.length <= 0 || $button.length <= 0) {
      return false;
    }

    $target.on('click', function () {
      $(this).toggleClass('is-mark');
      $(this).next($button).toggleClass('is-active');
    });
  }

  tingleBox() {
    function isMedicalAgreed() {
      return Cookies.get('medical_agree') ? true : false;
    }

    function saveMedicalAgreed() {
      Cookies.set('medical_agree', "1");
    }

    $(function () {
      let $tingleModal = $('#js-tingle-modal');
      if ($tingleModal.length <= 0) { return false; }
      $(document).on("click", ".js-agree", function () {
        saveMedicalAgreed();
        $('body').removeClass('no-scroll');
        $tingleModal.removeClass('is-active');
      });

      if (!isMedicalAgreed()) {
        $('body').addClass('no-scroll');
        $tingleModal.addClass('is-active');
      }
    })
  }

  documentTabHeight() {
    let $tabNav = $('.c-card-documents__tabs-nav');
    if ($tabNav.length <= 0) { return false;}
    let $tabNavHeight = $tabNav.height();
    $tabNav.css('height',$tabNavHeight);
  }
  // mycode() {
  //
  // }


}




